import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function PrivacyPage() {
  return (
    <div className="bg-grain min-h-screen" data-testid="privacy-page">
      <Header />
      <main className="py-16 md:py-20">
        <div className="max-w-3xl mx-auto px-5 sm:px-8 prose-invert">
          <span className="pill">Legal</span>
          <h1 className="mt-5 font-display font-black text-white text-4xl md:text-5xl tracking-tighter">
            Privacy Policy
          </h1>
          <p className="mt-4 text-[#A0AABF] text-sm">Last updated: {new Date().toLocaleDateString()}</p>
          <div className="mt-8 space-y-6 text-[#A0AABF] leading-relaxed">
            <Section title="What we collect">
              When you purchase from ContentSnap, we collect your name, email, business details (industry, brand colors, audience, tone, products/services, social links), and payment information processed through Stripe. We do not store credit card numbers on our servers.
            </Section>
            <Section title="How we use it">
              We use your information solely to deliver the content you ordered, communicate about your project, and improve our service. We do not sell, rent, or share your data with third parties.
            </Section>
            <Section title="Payments">
              All payments are processed by Stripe. ContentSnap never sees or stores raw payment card details. By purchasing, you agree to Stripe's terms.
            </Section>
            <Section title="Cookies">
              We use minimal cookies for session continuity and to verify successful payments after Stripe redirects. No advertising trackers.
            </Section>
            <Section title="Cancellation">
              For monthly subscriptions, you can cancel anytime by emailing contentsnapbrand@gmail.com or using the contact form. Cancellation takes effect at the end of your current billing cycle. No prorated credits.
            </Section>
            <Section title="Refunds">
              <strong className="text-white">All sales are final. No refunds.</strong> See our <a href="/terms" className="text-[#3B9EFF] hover:underline">Terms of Service</a> for full details on our revision policy (one revision per order).
            </Section>
            <Section title="Contact">
              Questions about this policy? Email us at <a href="mailto:contentsnapbrand@gmail.com" className="text-[#3B9EFF] hover:underline">contentsnapbrand@gmail.com</a>.
            </Section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

const Section = ({ title, children }) => (
  <div>
    <h2 className="font-display text-2xl font-bold text-white">{title}</h2>
    <p className="mt-2">{children}</p>
  </div>
);
